export default __webpack_public_path__ + "1fc9faea57461ed6a3422acfb0132b02.png";